import React from "react";
const ReactApexChart = React.lazy(() => import("react-apexcharts"));

function LineChart({ chartOpt }) {
  return (
    <div id="chart">
      <ReactApexChart
        options={chartOpt.options}
        series={chartOpt.series}
        height={350}
        type="area"
      />

      {/* <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="line"
        height={350}
      /> */}
    </div>
  );
}

export default LineChart;
